import templates from '../../../ui/widgets/resource-entry/templates';
import { buildNoRecordsConfig, getStartDateForData } from './schedule-five-individual-combined-elements';
import { TITLE_WIDTH, TOTAL_WIDTH, registerSummaryGridRefresher } from './schedule-five-summary-shared';

let _k_totalsGrid = null;

const createTotalsGridInternal = (data, startDate, opts = {}) => {
    const $totalsGrid = $('.grid.totals-grid');
    _k_totalsGrid?.grid?.destroy();
    $totalsGrid.empty();

    _k_totalsGrid = $totalsGrid
        .kendoResourceEntry({
            columnWidth: 120,
            dataSource: {
                schema: {
                    model: {
                        id: 'id',
                        fields: {
                            title: { editable: false, type: 'string' },
                            total: { editable: false, type: 'number' },
                        },
                    },
                },
                data: data,
            },
            staticColumns: [
                {
                    field: 'title',
                    type: 'string',
                    title: '&nbsp;',
                    width: TITLE_WIDTH,
                    editable: false,
                },
                {
                    field: 'total',
                    type: 'number',
                    template: templates.columnBased('total', 'format'),
                    title: 'Total',
                    width: TOTAL_WIDTH,
                    editable: false,
                },
            ],
            readonly: true,
            startDate: startDate,
            input: {
                type: 'columnBased',
                typeColumn: 'format',
            },
            dataBound() {
                //Hide Totals footer
                $('.grid.totals-grid div.k-grid-footer').hide();
            },
            grid: {
                ...buildNoRecordsConfig(opts.suppressNoRecords),
            },
        })
        .data('kendoResourceEntry');
};

const createTotalsGrid = (filters = {}) => {
    const $totalsGrid = $('.grid.totals-grid');
    const company = $totalsGrid.data('company');
    return $.getJSON('/Operations/ScheduleFiveOverview/GetOverviewTotals', { company, ...filters }).done(data => {
        const startDate = getStartDateForData(data);
        createTotalsGridInternal(data, startDate);
    });
};

export const getTotalsGrid = () => _k_totalsGrid?.grid;

export const refreshTotalsGrid = () => {
    _k_totalsGrid.grid.refresh();
};

export const initTotalsGrid = () => {
    registerSummaryGridRefresher(createTotalsGrid);
    createTotalsGridInternal([], new Date(), { suppressNoRecords: true });
    kendo.ui.progress($('.s5-totals-wrap'), true);

    return Promise.all([createTotalsGrid()])
        .then(() => {
            kendo.ui.progress($('.s5-totals-wrap'), false);
        })
        .catch(() => {
            kendo.ui.progress($('.s5-totals-wrap'), false);
        });
};
